module.exports = __webpack_public_path__ + "img/title_1.16fbc882.png";